import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import React, {useState, useEffect} from 'react'
import { useSelector } from 'react-redux'

import { Paper, Typography, Avatar, Chip } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    paper: {
        height: "100%", boxSizing: "border-box", padding: theme.spacing(4),
        borderRadius: 16, border: "1px solid #e3e9f0", boxShadow: "0 3px 14px rgba(30, 50, 80, 0.04)",
    },
    username: { marginTop: theme.spacing(3), overflowWrap: "anywhere" },
    name: { fontSize: 23, fontWeight: 600, color: "#243247", marginBottom: theme.spacing(1) },
    email: { fontSize: 15, color: "#637186", marginBottom: theme.spacing(3) },
    avatar: {
        marginTop: theme.spacing(3), width: 72, height: 72,
        color: "#007bff", backgroundColor: "#edf5ff", borderRadius: 20,
    },
    role: { marginTop: theme.spacing(1), backgroundColor: "#f0f5fb", color: "#52647b", fontSize: 11, fontWeight: 600 },

}));

const roleLevels = ["READER", "AUTHOR", "ADMIN"]

export default function UserInfo() {
    const classes = useStyles();
    const user = useSelector((state) => state.auth.user)

    const [username, setUsername] = useState("");
    const [name, setName] = useState("")
    const [company, setCompany] = useState("")
    const [accessLevel, setAccessLevel] = useState("")

    useEffect(() => {
        if (user){
            setName(user.name)
            setCompany(user.company)
            setAccessLevel(user.accessLevel)
            setUsername(user.email)
        }
    }, [user])

    return (
        <Paper className={classes.paper} elevation={0}>
            <Typography variant="h6" style={{ fontSize: 18, fontWeight: 600 }}>Account details</Typography>
            <Avatar className={classes.avatar}><PersonOutlineIcon style={{ fontSize: 38 }} /></Avatar>
            <div className={classes.username}>
                <Typography component="h2" className={classes.name}>{name}</Typography>
                <Typography className={classes.email}>{username}</Typography>
                <Typography variant="overline" color="textSecondary">Organization</Typography>
                <Typography style={{ fontSize: 15, fontWeight: 500 }}>{company.toUpperCase()}</Typography>
                {roleLevels[accessLevel - 1] && <Chip size="small" className={classes.role} label={roleLevels[accessLevel - 1]} />}
            </div>
        </Paper>
    )
}
